(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baubeau-collection-page"] && !Shopify.designMode) return;
  try {
    
/* BAUBEAU COLLECTION PAGE v4.3 — zéro {{ }} dans ce bloc */
document.querySelectorAll('[data-bb-section-id]').forEach(function(section) {

  /* Inline/sidebar supprimés — drawer only */

  /* ══════════════════════════════════════════════════════════
     DRAWER FILTRE — dialog natif + fetch compteur dynamique
     ══════════════════════════════════════════════════════════ */
  var drawer      = section.querySelector('[data-filter-drawer]');
  var drawerForm  = section.querySelector('[data-drawer-form]');
  var applyBtn    = section.querySelector('[data-drawer-apply]');
  var btnLabel    = section.querySelector('[data-drawer-btn-label]');
  var clearLink   = section.querySelector('[data-drawer-clear]');
  var openBtns    = section.querySelectorAll('[data-open-drawer]');
  var closeBtn    = section.querySelector('[data-close-drawer]');
  var collUrl     = section.dataset.collectionUrl || window.location.pathname;

  /* — Backdrop div — injecté une seule fois dans le DOM — */
  var backdrop = section.querySelector('[data-drawer-backdrop]');
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.className = 'bb-drawer-backdrop';
    backdrop.setAttribute('aria-hidden', 'true');
    backdrop.setAttribute('data-drawer-backdrop', '');
    document.body.appendChild(backdrop);
  }

  if (drawer) {

    /* — Ouvrir le drawer — */
    function openDrawer() {
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      /* Focus le premier élément interactif dans le drawer */
      var firstFocusable = drawer.querySelector('button, input, a, [tabindex]');
      if (firstFocusable) setTimeout(function() { firstFocusable.focus(); }, 50);
    }

    openBtns.forEach(function(btn) {
      btn.addEventListener('click', openDrawer);
    });

    /* — Fermer le drawer avec animation — */
    function closeDrawer() {
      drawer.classList.add('is-closing');
      backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
      drawer.addEventListener('animationend', function handler() {
        drawer.classList.remove('is-closing', 'is-open');
        drawer.removeEventListener('animationend', handler);
      }, { once: true });
      /* Fallback si animationend ne fire pas (prefers-reduced-motion) */
      setTimeout(function() {
        drawer.classList.remove('is-closing', 'is-open');
        backdrop.classList.remove('is-open');
        document.body.style.overflow = '';
      }, 350);
    }

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    /* Fermer au clic sur le backdrop */
    backdrop.addEventListener('click', closeDrawer);

    /* Fermer à Escape */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    /* ── Swipe-to-close — zone pilotée par data-swipe-mode ─────────────────── */
    var swipeMode   = drawer.dataset.swipeMode || 'header';
    var dragZone    = swipeMode === 'pill'
                        ? drawer.querySelector('.bb-filter-drawer__pill-zone')
                        : drawer.querySelector('.bb-filter-drawer__head');
    var drawerBody  = drawer.querySelector('[data-drawer-body]');
    var CLOSE_THRESHOLD = 80; /* px — seuil sous lequel spring-back */
    var dragStartY  = 0;
    var dragCurrentY = 0;
    var dragActive  = false;

    function onDragStart(e) {
      /* Ne pas initier si le corps est scrollé */
      if (drawerBody && drawerBody.scrollTop > 0) return;
      dragActive   = true;
      dragStartY   = (e.touches ? e.touches[0] : e).clientY;
      dragCurrentY = 0;
      drawer.classList.remove('is-closing');
      drawer.style.transition = 'none';
    }

    function onDragMove(e) {
      if (!dragActive) return;
      var dy = (e.touches ? e.touches[0] : e).clientY - dragStartY;
      if (dy < 0) dy = 0;
      dragCurrentY = dy;
      drawer.style.transform = 'translateY(' + dy + 'px)';
      /* Assombrir le backdrop progressivement */
      var backdrop = document.querySelector('.bb-drawer-backdrop');
      if (backdrop) {
        var opacity = 0.42 * (1 - Math.min(dy / CLOSE_THRESHOLD, 1) * 0.7);
        backdrop.style.background = 'rgba(0,0,0,' + opacity + ')';
      }
      if (e.cancelable) e.preventDefault();
    }

    function onDragEnd() {
      if (!dragActive) return;
      dragActive = false;
      drawer.style.transition = '';
      var backdrop = document.querySelector('.bb-drawer-backdrop');
      if (dragCurrentY > CLOSE_THRESHOLD) {
        /* Fermer */
        if (backdrop) backdrop.style.background = '';
        closeDrawer();
      } else {
        /* Spring-back */
        drawer.style.transition = 'transform 0.35s cubic-bezier(0.34,1.56,0.64,1)';
        drawer.style.transform  = 'translateY(0)';
        if (backdrop) backdrop.style.background = '';
        setTimeout(function() { drawer.style.transition = ''; }, 400);
      }
    }

    if (dragZone) {
      dragZone.addEventListener('touchstart', onDragStart, { passive: true });
      dragZone.addEventListener('touchmove',  onDragMove,  { passive: false });
      dragZone.addEventListener('touchend',   onDragEnd);
      /* Curseur grab desktop (pour la démo) */
      dragZone.style.cursor = 'grab';
    }
    /* ── fin swipe-to-close ─────────────────────────────────────────────────── */

    /* — Accordéons drawer — .is-open au lieu de hidden pour compatibilité Safari iOS ——— */
    section.querySelectorAll('[data-drawer-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation(); /* Empêche la propagation vers le dialog → évite fermeture accidentelle */
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!expanded));
        var body = this.nextElementSibling;
        if (body) {
          body.classList.toggle('is-open', !expanded);
        }
      });
    });

    /* — Radio tri : mettre à jour l'input hidden sort_by — */
    section.querySelectorAll('[data-drawer-sort]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        /* Mettre à jour le label visuel actif */
        section.querySelectorAll('[data-drawer-sort]').forEach(function(r) {
          r.closest('.bb-drawer-radio__item').classList.toggle('is-active', r.checked);
        });
        /* Mettre à jour l'input hidden sort_by */
        var hiddenSort = drawerForm.querySelector('[data-drawer-sort-hidden]');
        if (hiddenSort) hiddenSort.value = this.value;
        fetchCount();
      });
    });

    /* — Fetch dynamique du compteur — */
    var fetchTimer = null;

    function fetchCount() {
      if (!drawerForm || !applyBtn || !btnLabel) return;

      /* Indiquer le chargement */
      btnLabel.textContent = '…';
      applyBtn.setAttribute('data-loading', '');

      /* Construire les params depuis le formulaire drawer */
      var params = new URLSearchParams(new FormData(drawerForm));
      /* Nettoyer les valeurs vides */
      var cleanParams = new URLSearchParams();
      params.forEach(function(val, key) {
        if (val !== '' && val !== null) cleanParams.append(key, val);
      });

      /* Ajouter section_id pour que Shopify renvoie le HTML de la section */
      cleanParams.set('section_id', section.dataset.bbSectionId);

      var url = collUrl + '?' + cleanParams.toString();

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(res) { return res.text(); })
        .then(function(html) {
          /* Parser le HTML retourné et extraire le products_count */
          var parser = new DOMParser();
          var doc    = parser.parseFromString(html, 'text/html');
          var countEl = doc.querySelector('[data-products-count]');
          var count   = countEl ? countEl.textContent.trim() : null;

          if (count) {
            /* Extraire le nombre seul (ex: "27 pièces" → 27) */
            var num = parseInt(count, 10);
            if (!isNaN(num)) {
              btnLabel.textContent = 'Voir les ' + num + ' produits';
            } else {
              btnLabel.textContent = 'Voir les résultats';
            }
          } else {
            btnLabel.textContent = 'Voir les résultats';
          }
        })
        .catch(function() {
          btnLabel.textContent = 'Voir les résultats';
        })
        .finally(function() {
          applyBtn.removeAttribute('data-loading');
        });
    }

    function scheduleFetch() {
      clearTimeout(fetchTimer);
      fetchTimer = setTimeout(fetchCount, 300);
    }

    /* Écouter tous les changements dans le formulaire drawer */
    section.querySelectorAll('[data-drawer-filter-input]').forEach(function(input) {
      var evt = input.type === 'number' ? 'input' : 'change';

      /* Sync visuel .is-active sur le label parent — checkbox et radio */
      input.addEventListener('change', function() {
        var label = this.closest('label');
        if (!label) return;
        if (this.type === 'checkbox') {
          label.classList.toggle('is-active', this.checked);
        } else if (this.type === 'radio') {
          /* Pour les radios (tri) : retirer is-active de tous, ajouter sur celui coché */
          var name = this.name;
          section.querySelectorAll('[data-drawer-filter-input][type="radio"][name="' + name + '"]').forEach(function(r) {
            var rLabel = r.closest('label');
            if (rLabel) rLabel.classList.toggle('is-active', r.checked);
          });
        }
      });

      input.addEventListener(evt, scheduleFetch);
    });

    /* — Bouton Appliquer : soumettre le formulaire drawer — */
    if (applyBtn) {
      applyBtn.addEventListener('click', function() {
        if (drawerForm) {
          /* Supprimer l'input hidden sort_by du form pour éviter le doublon avec le radio */
          var hiddenSort = drawerForm.querySelector('[data-drawer-sort-hidden]');
          if (hiddenSort) hiddenSort.remove();
          drawerForm.submit();
        }
      });
    }

    /* — Lien Effacer tout — */
    if (clearLink) {
      clearLink.addEventListener('click', function(e) {
        e.preventDefault();
        var href = clearLink.href;
        closeDrawer();
        setTimeout(function() { window.location.href = href; }, 280);
      });
    }

  } /* end if (drawer) */

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
